@if (inputLabel) {
  <label [attr.for]="attrLabel" class="input-label" [ngClass]="{'input-error-text-color': hasError}">{{(isRequired ? '* ': '') + inputLabel | titlecase}}</label>
}
<div class="text-input-container {{ TextInputVariants[variant]}} hmf-p-xxs hmf-p-l-xs" [ngStyle]="{'width': width}" [ngClass]="{'input-error-style-border input-error-background': hasError, 'input-disabled-background': isDisabled}">
  @if (inlineLabel) {
    <div class="nested-label">
      {{inlineLabel}}
    </div>
  }
  <ng-content></ng-content>
  @if (hasError) {
    <homefield-icon
      width="15px"
      height="15px"
      fill="var(--hmf-text-input-error-svg-fill)"
      name="alert-error-filled">
    </homefield-icon>
  }
</div>
@if (optionalText) {
  <div class="hmf-ml-xs hmf-mt-xxxs input-optional-text" [ngClass]="{'input-error-text-color': hasError}">{{optionalText}}</div>
}